import { render, staticRenderFns } from "./BtnCancelarMeta.vue?vue&type=template&id=db1c9860"
import script from "./BtnCancelarMeta.vue?vue&type=script&lang=js"
export * from "./BtnCancelarMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports